/**
 * Design system della landing.
 *
 * Regole d'uso:
 * - le tinte, i raggi e il ritmo verticale stanno nei token di `globals.css`
 *   (blocco «Design system landing v2»), mai in valori sparsi nei componenti;
 * - ogni sezione è `<Section>` + `<Container>`, una sola CTA `accent` per sezione;
 * - l'arancione è riservato a occhielli, CTA primaria e link con freccia;
 * - i movimenti passano da `<Reveal>` o da GSAP, sempre con fallback per
 *   `prefers-reduced-motion`.
 */
export { default as ArrowLink } from './ArrowLink';
export { default as Card } from './Card';
export { default as CheckList } from './CheckList';
export { default as Chip } from './Chip';
export { default as Container } from './Container';
export { default as CtaButton } from './CtaButton';
export { default as CtaPanel } from './CtaPanel';
export { default as Eyebrow } from './Eyebrow';
export { default as Heading } from './Heading';
export { default as Marquee } from './Marquee';
export { default as QaCard } from './QaCard';
export { default as AnswerText, InlineText } from './AnswerText';
export { default as QuoteAvatar } from './QuoteAvatar';
export { default as Reveal } from './Reveal';
export { default as Section } from './Section';
export { default as SectionIntro, WIDE_HEADING } from './SectionIntro';
export { SignupCtaGroup, SignupNote } from './SignupCta';
export { default as Stat } from './Stat';
export { default as Attribution } from './Attribution';
export { default as Testimonial } from './Testimonial';
export { default as Text } from './Text';
